// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--36fc0";
export var footerContent = "footer-module--footerContent--d4b06";
export var footerCopyright = "footer-module--footerCopyright--6058d";
export var footerLinks = "footer-module--footerLinks--683bb";